// general colors
export const BORDER_DIALOG_COLOR = '#DCDCDC';
export const BUTTON_RED_COLOR = '#FA613F';
export const FIELD_PRESSED_COLOR = '#5683C9';
export const NEUTRAL_COLOR = '#6B6E84';
export const TEXT_DARK_COLOR = '#454B60';
export const TEXT_LIGHT_COLOR = '#868A99';
export const HOVER_HIGHLIGHT_COLOR = '#F5F5F5';
export const DEFAULT_DARK_COLOR = '#000000';
export const DEFAULT_LIGHT_COLOR = '#ffffff';
export const DEFAULT_DISABLED_BACKGROUND = '#ffffff61';
export const FONT_COLOR = '#7B7D85';

// primary colors
export const CHIP_BACKGROUND_SUCCESS_COLOR = '#E1F4EC';
export const CHIP_FONT_SUCCESS_COLOR = '#1FB877';
export const CHIP_BACKGROUND_PENDING_COLOR = '#fefe7f';
export const CHIP_FONT_PENDING_COLOR = '#FFC400';
export const CHIP_BACKGROUND_FAILURE_COLOR = '#ffae9d';
export const CHIP_FONT_FAILURE_COLOR = '#E44B5D';
export const PRIMARY_BACKGROUND_COLOR = '#F3F3F7';
export const PRIMARY_BORDER_COLOR = '#CACAF1';
export const PRIMARY_DARK_COLOR = '#1A1F4F';
export const PRIMARY_ERROR_COLOR = '#E44B5D';
export const PRIMARY_WARNING_COLOR = '#FFC400';
export const PRIMARY_SUCCESS_COLOR = '#1FB877';
export const PRIMARY_THEME_COLOR = '#393F73';
// secondary colors
export const SECONDARY_THEME_COLOR = '#686D93';
export const SECONDRARY_BACKGROUND_COLOR = '#EAEAF9';
